import { render, staticRenderFns } from "./SensorPage.vue?vue&type=template&id=d0dfc078&scoped=true&"
import script from "./SensorPage.vue?vue&type=script&lang=ts&"
export * from "./SensorPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dfc078",
  null
  
)

export default component.exports